import { Dispatch } from 'redux';
import {
  httpError,
  fetchPost,
  blob,
  showWarnNotification,
  showSuccessNotification,
  getDataTypeName,
} from 'common';
import { SEARCH_EXPORT_CLEAR, SEARCH_EXPORT_LOADING } from 'pages/Search';
import { printFile, saveFile } from 'common/helpers';
import { AppState } from 'store';
import { formValueSelector } from 'redux-form';
import { NYC_DB_FORM_NAME } from '../SearchForm/consts';

export function searchExportClear() {
  return {
    type: SEARCH_EXPORT_CLEAR,
  };
}

export function searchExportLoading(loading: boolean) {
  return {
    type: SEARCH_EXPORT_LOADING,
    payload: loading,
  };
}

export function fetchFileAsync(format: string, bearerToken: string) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return (dispatch: Dispatch, getState: () => AppState) => {
    const state = getState();

    const tabName = formValueSelector(NYC_DB_FORM_NAME)(state, 'tab');
    const fetchContent = state.search[getDataTypeName(tabName)];

    dispatch(searchExportLoading(true));
    fetchPost(
      `${apiUri}/nycDatabase/searchBy${tabName}/export/${format}`,
      fetchContent,
      bearerToken,
    )
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(searchExportLoading(false));
        saveFile(blob, `Report.${format}`);
        showSuccessNotification(`Fetch file`, `File was exported`);
      })
      .catch((error) => {
        dispatch(searchExportLoading(false));
        showWarnNotification(`Fetch file`, error.message);
      });
  };
}

export function fetchHtmlPrintAsync(bearerToken: string) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return (dispatch: Dispatch, getState: () => AppState) => {
    const state = getState();
    const tabName = formValueSelector(NYC_DB_FORM_NAME)(state, 'tab');
    const fetchContent = state.search[getDataTypeName(tabName)];

    dispatch(searchExportLoading(true));
    fetchPost(
      `${apiUri}/nycDatabase/searchBy${tabName}/export/html`,
      fetchContent,
      bearerToken,
    )
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(searchExportLoading(false));
        printFile(blob);
      })
      .catch((error) => {
        dispatch(searchExportLoading(false));
        showWarnNotification(`Fetch file`, error.message);
      });
  };
}

export function exportDetailsAsync(
  body: any,
  searchId: any,
  type: string,
  format: string,
  action: 'print' | 'save',
  token: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;
  return (dispatch: Dispatch) => {
    dispatch(searchExportLoading(true));
    fetchPost(
      `${apiUri}/nycDatabase/export/${searchId}/details/${type}/${format}`,
      body,
      token,
    )
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(searchExportLoading(false));
        if (action === 'print') {
          printFile(blob);
        }
        if (action === 'save') {
          saveFile(blob, `Report.${format}`);
          showSuccessNotification(`Fetch file`, `File was exported`);
        }
      })
      .catch((error) => {
        dispatch(searchExportLoading(false));
        showWarnNotification(`Fetch details file`, error.message);
      });
  };
}
